import { Link } from "react-router-dom";
import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import SEOMeta from "../../components/base/SEOMeta";

const sections = [
  {
    id: "overview",
    title: "1. Overview",
    content: [
      "FunsTest (\"we\", \"our\", or \"us\") operates the website funstest.com (the \"Site\"). This Privacy Policy explains how we collect, use, disclose, and protect your information when you visit our Site.",
      "By using FunsTest, you agree to the collection and use of information in accordance with this policy. We are committed to maintaining the trust and confidence of all visitors to our website, particularly our younger audience.",
      "This policy was last updated on March 25, 2026. We reserve the right to update this Privacy Policy at any time. We will notify users of significant changes by posting the new policy on this page with an updated date.",
    ],
  },
  {
    id: "information-we-collect",
    title: "2. Information We Collect",
    content: [
      "We collect several types of information in connection with the services we provide:",
      "**Usage Data:** We automatically collect information about how you interact with the Site, including pages visited, quiz results viewed, time spent on pages, browser type, device type, operating system, and IP address (anonymized where possible).",
      "**Cookies and Tracking Technologies:** We use cookies, web beacons, and similar tracking technologies to enhance your experience, display relevant advertising, and analyze site traffic. For full details, see Section 5 (Cookies Policy) below.",
      "**Email Address (Optional):** If you subscribe to our newsletter, we collect your email address solely to send you our weekly quiz updates. You may unsubscribe at any time via the link in any email.",
      "**Form Submissions:** If you submit a quiz idea through our \"Write for Us\" form, we collect the information you voluntarily provide, such as your name, email, and quiz content.",
      "We do NOT collect passwords, payment information, Social Security numbers, or other sensitive personal data.",
    ],
  },
  {
    id: "how-we-use",
    title: "3. How We Use Your Information",
    content: [
      "We use the information we collect for the following purposes:",
      "• To operate and improve the FunsTest website and quiz experience.",
      "• To personalize content and display quizzes relevant to your interests.",
      "• To send newsletter emails to subscribers who have opted in.",
      "• To analyze traffic patterns and improve site performance through aggregated analytics.",
      "• To display third-party advertisements through Google AdSense and other advertising partners.",
      "• To comply with legal obligations and enforce our Terms of Use.",
      "• To respond to inquiries submitted via our contact or feedback forms.",
      "We do not sell, rent, or trade your personal information to unaffiliated third parties for their marketing purposes.",
    ],
  },
  {
    id: "google-adsense",
    title: "4. Google AdSense & Third-Party Advertising",
    content: [
      "FunsTest uses Google AdSense to display advertisements on our Site. Google AdSense is a program run by Google LLC that allows us to earn revenue by displaying relevant ads.",
      "**How Google AdSense Works:** Google uses cookies and similar technologies (such as the DoubleClick DART cookie) to serve ads based on your prior visits to our Site and other websites on the Internet. These cookies enable Google and its partners to serve ads to users based on their visit to our site and/or other sites on the Internet.",
      "**Opting Out of Personalized Ads:** You may opt out of personalized advertising by visiting Google\'s Ads Settings page at https://www.google.com/settings/ads. Alternatively, you can opt out of a third-party vendor\'s use of cookies for personalized advertising by visiting www.aboutads.info.",
      "**Third-Party Ad Networks:** In addition to Google AdSense, we may work with other advertising networks and partners. These third parties may use cookies, web beacons, or similar technologies to collect information about your visits to this and other websites in order to provide advertisements about goods and services of interest to you.",
      "**No Control Over Third-Party Practices:** We do not have access to or control over the cookies or other tracking technologies that third-party advertisers may use. We encourage you to review the privacy policies of these advertising partners for more information.",
      "The Google Privacy Policy can be found at: https://policies.google.com/privacy",
    ],
  },
  {
    id: "cookies",
    title: "5. Cookies Policy",
    content: [
      "Cookies are small text files stored on your device when you visit a website. FunsTest uses the following types of cookies:",
      "**Strictly Necessary Cookies:** These cookies are essential for the Site to function properly. They enable basic functions like page navigation and cannot be switched off.",
      "**Performance / Analytics Cookies:** We use analytics services (such as Google Analytics) to understand how visitors interact with our Site. These cookies collect information in an anonymous, aggregated form, including the number of visitors, the pages they visit, and how they interact with quizzes.",
      "**Advertising Cookies (Third-Party):** Google AdSense and other advertising partners place cookies on your device to show you relevant ads. These cookies track your browsing habits across websites to build a profile of your interests. We do not control these cookies — they are governed by the privacy policies of the respective advertising partners.",
      "**Preference Cookies:** These cookies allow the website to remember choices you have made (such as your preferred quiz category) to provide a more personalized experience.",
      "**Managing Cookies:** Most web browsers allow you to control cookies through their settings. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, some features of the Site may not function correctly.",
      "By continuing to use our Site after being informed of our cookie usage, you consent to our use of cookies as described in this policy.",
    ],
  },
  {
    id: "children",
    title: "6. Children\'s Privacy (COPPA Compliance)",
    content: [
      "FunsTest is intended for users aged 13 and older. We are committed to complying with the Children\'s Online Privacy Protection Act (COPPA) and applicable international children\'s privacy laws.",
      "**Under-13 Users:** We do not knowingly collect personally identifiable information from children under the age of 13. If you are a parent or guardian and believe your child under 13 has provided personal information to us, please contact us immediately at privacy@funstest.com. We will promptly delete such information.",
      "**Advertising to Minors:** We take precautions to limit interest-based advertising directed at users who are under the age of 18. We have enabled Google\'s \"Restrict data processing\" feature as a safeguard for younger users.",
      "**Parental Controls:** We encourage parents and guardians to monitor their children\'s online activities and to educate them about safe internet practices. If you have concerns about your child\'s use of FunsTest, please do not hesitate to contact us.",
      "**Our Content Standards:** All quiz results and content on FunsTest are designed to be positive, age-appropriate, and free from harmful or negative messaging. We manually review quiz content before publishing.",
    ],
  },
  {
    id: "data-sharing",
    title: "7. Data Sharing & Third Parties",
    content: [
      "We do not sell personal information. However, we may share data in the following limited circumstances:",
      "**Service Providers:** We may share information with trusted third-party service providers who assist us in operating the Site, such as hosting providers, email delivery services, and analytics platforms. These providers are contractually required to keep your information confidential.",
      "**Google Analytics:** We use Google Analytics to analyze traffic on our Site. Google Analytics collects data such as how often users visit the site, what pages they visit, and what other sites they used prior to visiting. We use this data to improve the Site. Google\'s use of this data is governed by its own privacy policy.",
      "**Legal Requirements:** We may disclose your information if required to do so by law, or in response to valid requests by public authorities (e.g., a court or government agency).",
      "**Business Transfers:** In the event of a merger, acquisition, or sale of company assets, user information may be transferred as part of the transaction. We will provide notice before your information is transferred and becomes subject to a different Privacy Policy.",
    ],
  },
  {
    id: "data-security",
    title: "8. Data Security & Retention",
    content: [
      "We implement reasonable security measures to protect your information from unauthorized access, disclosure, alteration, or destruction. These include encrypted data transmission (HTTPS), access controls, and regular security reviews.",
      "However, no method of transmission over the Internet or method of electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your information, we cannot guarantee absolute security.",
      "**Retention:** We retain newsletter email addresses for as long as you remain subscribed. Form submission data is retained for up to 12 months or until you request deletion. Usage and analytics data is retained in anonymized form for up to 26 months per Google Analytics defaults.",
      "You may request deletion of your personal data at any time by contacting us at privacy@funstest.com.",
    ],
  },
  {
    id: "your-rights",
    title: "9. Your Rights",
    content: [
      "Depending on your location, you may have the following rights regarding your personal information:",
      "**Access:** You have the right to request a copy of the personal data we hold about you.",
      "**Correction:** You have the right to request that we correct any inaccurate or incomplete personal data.",
      "**Deletion:** You have the right to request that we delete your personal data, subject to certain legal exceptions.",
      "**Opt-Out:** You may opt out of our newsletter at any time by clicking the unsubscribe link in any email we send, or by contacting us directly.",
      "**Do Not Track:** Some browsers include a \"Do Not Track\" feature. Our Site does not currently respond to Do Not Track signals, but you may use the cookie management tools described in Section 5 to limit data collection.",
      "To exercise any of these rights, please contact us at privacy@funstest.com. We will respond to your request within 30 days.",
    ],
  },
  {
    id: "contact",
    title: "10. Contact Us",
    content: [
      "If you have any questions, concerns, or requests regarding this Privacy Policy or our data practices, please contact us:",
      "**Email:** privacy@funstest.com",
      "**Website:** funstest.com/feedback",
      "We take privacy seriously and will do our best to address your concerns promptly and thoroughly.",
    ],
  },
];

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

const privacyJsonLd = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": "Privacy Policy | QuizVibe",
  "description": "QuizVibe Privacy Policy – how we collect, use, and protect your information. Includes Google AdSense, cookie disclosures, and COPPA compliance for kids.",
  "url": `${SITE_URL}/privacy`,
  "inLanguage": "en",
  "dateModified": "2026-03-25",
  "breadcrumb": {
    "@type": "BreadcrumbList",
    "itemListElement": [
      { "@type": "ListItem", "position": 1, "name": "Home", "item": SITE_URL },
      { "@type": "ListItem", "position": 2, "name": "Privacy Policy", "item": `${SITE_URL}/privacy` }
    ]
  },
  "publisher": {
    "@type": "Organization",
    "name": "QuizVibe",
    "url": SITE_URL
  }
};

export default function PrivacyPolicyPage() {
  return (
    <div className="min-h-screen bg-white">
      <SEOMeta
        title="Privacy Policy | QuizVibe – Kids & Teen Quiz Platform"
        description="Read QuizVibe's Privacy Policy. Learn how we collect and use data, our Google AdSense cookie disclosures, COPPA compliance for under-13 users, and your privacy rights."
        keywords="QuizVibe privacy policy, kids quiz privacy, COPPA compliance, cookie policy, data protection"
        canonicalPath="/privacy"
        jsonLd={privacyJsonLd}
      />
      <Navbar />

      {/* Hero */}
      <section className="pt-28 pb-16 bg-gradient-to-br from-[#FFF8F6] to-[#FFF3ED]">
        <div className="max-w-4xl mx-auto px-6">
          <div className="flex items-center gap-2 mb-4">
            <Link to="/" className="text-gray-400 hover:text-[#FF6B6B] text-sm transition-colors cursor-pointer">
              Home
            </Link>
            <i className="ri-arrow-right-s-line text-gray-300 text-sm" />
            <span className="text-[#FF6B6B] text-sm font-medium">Privacy Policy</span>
          </div>
          <div className="flex items-start gap-6">
            <div className="w-14 h-14 flex items-center justify-center rounded-2xl bg-gradient-to-br from-[#FF6B6B] to-[#FF8E53] flex-shrink-0 mt-1">
              <i className="ri-shield-check-line text-white text-2xl" />
            </div>
            <div>
              <h1
                className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-3"
                style={{ fontFamily: "'Nunito', sans-serif" }}
              >
                Privacy Policy
              </h1>
              <p className="text-gray-500 text-base">
                Last updated: <strong>March 25, 2026</strong>
                <span className="mx-3 text-gray-200">|</span>
                Effective date: <strong>January 1, 2021</strong>
              </p>
            </div>
          </div>

          {/* Quick info bar */}
          <div className="mt-8 grid grid-cols-1 sm:grid-cols-3 gap-4">
            {[
              { icon: "ri-lock-line", label: "We never sell your data", color: "text-[#FF6B6B]" },
              { icon: "ri-parent-line", label: "COPPA compliant for under-13 safety", color: "text-[#FF8E53]" },
              { icon: "ri-advertisement-line", label: "AdSense & cookie disclosures included", color: "text-[#FBBF24]" },
            ].map((item) => (
              <div key={item.label} className="flex items-center gap-3 bg-white rounded-xl px-4 py-3 border border-orange-50">
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                  <i className={`${item.icon} ${item.color} text-lg`} />
                </div>
                <span className="text-gray-600 text-sm font-medium">{item.label}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-6">
          <div className="flex gap-12">
            {/* TOC - sticky sidebar */}
            <aside className="hidden lg:block w-64 flex-shrink-0">
              <div className="sticky top-28">
                <p className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-4">On this page</p>
                <nav className="space-y-1">
                  {sections.map((s) => (
                    <a
                      key={s.id}
                      href={`#${s.id}`}
                      className="block text-sm text-gray-500 hover:text-[#FF6B6B] py-1.5 px-3 rounded-lg hover:bg-[#FFF8F6] transition-colors cursor-pointer"
                    >
                      {s.title}
                    </a>
                  ))}
                </nav>
                <div className="mt-8 bg-[#FFF8F6] rounded-2xl p-4 border border-orange-50">
                  <p className="text-xs font-bold text-gray-700 mb-2">Questions about privacy?</p>
                  <p className="text-xs text-gray-500 mb-3">We\'re happy to help clarify anything.</p>
                  <a
                    href="mailto:privacy@funstest.com"
                    className="block text-center text-xs font-bold text-[#FF6B6B] bg-white border border-[#FF6B6B]/30 rounded-full py-2 hover:bg-[#FF6B6B] hover:text-white transition-colors cursor-pointer"
                  >
                    Email Us
                  </a>
                </div>
              </div>
            </aside>

            {/* Main content */}
            <div className="flex-1 min-w-0">
              <div className="space-y-12">
                {sections.map((section) => (
                  <div key={section.id} id={section.id} className="scroll-mt-28">
                    <h2
                      className="text-xl font-extrabold text-gray-900 mb-5 pb-3 border-b border-gray-100"
                      style={{ fontFamily: "'Nunito', sans-serif" }}
                    >
                      {section.title}
                    </h2>
                    <div className="space-y-4">
                      {section.content.map((para, i) => {
                        if (para.startsWith("•")) {
                          return (
                            <div key={i} className="flex items-start gap-3">
                              <div className="w-1.5 h-1.5 rounded-full bg-[#FF6B6B] mt-2.5 flex-shrink-0" />
                              <p className="text-gray-600 text-sm leading-relaxed">{para.slice(2)}</p>
                            </div>
                          );
                        }
                        const parts = para.split(/\*\*(.*?)\*\*/g);
                        return (
                          <p key={i} className="text-gray-600 text-sm leading-relaxed">
                            {parts.map((part, j) =>
                              j % 2 === 1 ? (
                                <strong key={j} className="text-gray-800 font-semibold">{part}</strong>
                              ) : (
                                part
                              )
                            )}
                          </p>
                        );
                      })}
                    </div>
                  </div>
                ))}
              </div>

              {/* Footer note */}
              <div className="mt-16 p-6 bg-gradient-to-br from-[#FFF8F6] to-[#FFF3ED] rounded-2xl border border-orange-50">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-8 h-8 flex items-center justify-center">
                    <i className="ri-information-line text-[#FF6B6B] text-lg" />
                  </div>
                  <p className="font-bold text-gray-800 text-sm">Policy Changes</p>
                </div>
                <p className="text-gray-500 text-sm leading-relaxed">
                  We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last updated" date. We encourage you to review this Privacy Policy periodically for any changes.
                </p>
              </div>

              <div className="mt-8 flex flex-wrap gap-4">
                <Link
                  to="/terms"
                  className="inline-flex items-center gap-2 text-sm font-semibold text-[#FF6B6B] hover:underline cursor-pointer"
                >
                  <i className="ri-file-text-line" />
                  View Terms of Use
                </Link>
                <Link
                  to="/write-for-us"
                  className="inline-flex items-center gap-2 text-sm font-semibold text-gray-500 hover:text-[#FF6B6B] transition-colors cursor-pointer"
                >
                  <i className="ri-edit-line" />
                  Write for FunsTest
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
